module.exports = __webpack_public_path__ + "static/media/www.22061ba9.svg";